"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.getNonParamKeyVal = function (obj) {
    return Object.keys(obj)
        .filter(function (k) { return k !== 'param'; })
        .map(function (key) { return ({ key: key, val: obj[key] }); }).pop();
};
exports.getUrlParam = function (key, val, param) {
    return (val !== undefined) ?
        (param ? param : key) + "=" + (lodash_1.isArray(val) ? val.join(',') : val) : '';
};
exports.formatParams = function (args) { return args.reduce(function (acc, curr) {
    var param = curr.param, _a = exports.getNonParamKeyVal(curr), key = _a.key, val = _a.val, accStr = (acc) ? acc : '', prefix = (val !== undefined && acc) ? '&' : (val !== undefined) ? '?' : '';
    return "" + accStr + prefix + exports.getUrlParam(key, val, param);
}, undefined); };
//# sourceMappingURL=params.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/util/params.js
 ** module id = 253
 ** module chunks = 0
 **/